<div class="flex-row flex" *cbWaitFor="mappedItem">
    <div class="flex-col flex">
        <div class="flex-row">
            <div class="cb-margin-right-2x flex-col flex">
                <cb-select
                    name="designComplexity"
                    label="Design Complexity"
                    [options]="designComplexities"
                    labelProp="complexity"
                    [required]="true"
                    [(ngModel)]="designComplexityId"
                    (change)="updatedDesignComplexity()"
                >
                </cb-select>
            </div>
            <div class="flex-col flex">
                <cb-datepicker
                    label="Due Date"
                    name="dueDate"
                    pickerType="calendar"
                    [(ngModel)]="mappedItem.dueDate"
                    [required]="true"
                    [disabled]="!userIsInDesignTeam()"
                >
                </cb-datepicker>
            </div>
        </div>
        <cb-input
            type="number"
            label="Estimated Hours"
            name="estimatedHours"
            [ngModel]="mappedItem.estimatedHours"
        >
        </cb-input>
        <cb-user-autocomplete-scroller
            class="flex"
            [team]="DESIGN_TEAM"
            label="Assigned To"
            name="assignedToUserId"
            [(ngModel)]="mappedItem.assignedToUser"
            [requireMatch]="true"
            [matchProps]="['id']"
            [active]="true"
            [required]="true"
        >
        </cb-user-autocomplete-scroller>
        <cb-checkbox
            name="designReviewRequired"
            label="Design Review Required"
            [(ngModel)]="mappedItem.designReviewRequired"
            (change)="designReviewRequiredChanged()"
        ></cb-checkbox>
        @if (mappedItem.designReviewRequired) {
            <cb-user-autocomplete-scroller
                [tag]="DESIGN_SUPERVISOR"
                label="Reviewer"
                name="reviewerId"
                [(ngModel)]="reviewerUser"
                [requireMatch]="true"
                [matchProps]="['id']"
                [required]="true"
                [active]="true"
                (change)="reviewerChanged()"
            ></cb-user-autocomplete-scroller>
        }
    </div>
</div>
